var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0229 0.653076H3.97714C1.78408 0.653076 0 2.44287 0 4.64246V11.3572C0 13.5572 1.78408 15.3465 3.97714 15.3465H16.0229C18.2159 15.3465 20 13.5567 20 11.3572V4.64246C20 2.44287 18.2159 0.653076 16.0229 0.653076ZM19.1837 11.3576C19.1837 13.1074 17.7657 14.5306 16.0229 14.5306H3.97714C2.23429 14.5306 0.816326 13.107 0.816326 11.3576V4.64246C0.816326 2.89308 2.23429 1.4694 3.97714 1.4694H16.0229C17.7657 1.4694 19.1837 2.89308 19.1837 4.64246V11.3576Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6163 7.85226L7.96121 4.54002C7.83549 4.46655 7.67917 4.46532 7.55223 4.53797C7.42529 4.61063 7.34692 4.74573 7.34692 4.89226V11.5163C7.34692 11.6625 7.42529 11.798 7.55182 11.8706C7.61468 11.9065 7.68488 11.9245 7.75509 11.9245C7.82652 11.9245 7.89754 11.9057 7.96121 11.8686L13.6163 8.55716C13.7412 8.4841 13.8184 8.34981 13.8184 8.20491C13.8184 8.06002 13.7416 7.92532 13.6163 7.85226ZM8.16325 10.8041V5.6041L12.6024 8.2045L8.16325 10.8041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.23c82fcf5384b3f5f3d5f72bc4d4d553.svg";
export { ForwardRef as ReactComponent };